const foldLine = (s) => s.match(/.{1,74}/g).join("\r\n ");

export function buildVCard(card, photoB64) {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${card.name || ""}`,
    card.company ? `ORG:${card.company}` : "",
    card.title ? `TITLE:${card.title}` : "",
    card.phone ? `TEL;TYPE=CELL:${card.phone}` : "",
    card.phone2 ? `TEL;TYPE=WORK:${card.phone2}` : "",
    card.email ? `EMAIL;TYPE=INTERNET:${card.email}` : "",
    card.email2 ? `EMAIL;TYPE=INTERNET:${card.email2}` : "",
    card.website ? `URL:${card.website}` : "",
    ...(card.social_links || []).filter(Boolean).map((u) => `URL:${u}`),
    card.address ? `ADR;TYPE=WORK:;;${card.address};;;;` : "",
    card.industry ? `CATEGORIES:${card.industry}` : "",
    card.notes ? `NOTE:${card.notes.replace(/\n/g, "\\n")}` : "",
    photoB64 ? foldLine(`PHOTO;ENCODING=b;TYPE=JPEG:${photoB64}`) : "",
    "END:VCARD",
  ].filter(Boolean);
  return lines.join("\r\n");
}

export function downloadVCard(card) {
  const blob = new Blob([buildVCard(card)], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(card.name || "contact").replace(/\s+/g, "_")}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function triggerDownload(content, mime, filename) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function buildVCardBatch(cards) {
  return (cards || []).map((c) => buildVCard(c)).join("\r\n");
}

export function downloadAllVCards(cards, filename = "dextyou-contacts.vcf") {
  triggerDownload(buildVCardBatch(cards), "text/vcard", filename);
}

const CSV_COLUMNS = [
  ["name", "Name"],
  ["title", "Title"],
  ["company", "Company"],
  ["industry", "Industry"],
  ["phone", "Phone"],
  ["phone2", "Phone 2"],
  ["email", "Email"],
  ["email2", "Email 2"],
  ["website", "Website"],
  ["address", "Address"],
  ["social_links", "Social Links"],
  ["notes", "Notes"],
];

function csvCell(value) {
  const s = Array.isArray(value) ? value.filter(Boolean).join(" | ") : value == null ? "" : String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function buildCSV(cards) {
  const header = CSV_COLUMNS.map(([, label]) => csvCell(label)).join(",");
  const rows = (cards || []).map((c) => CSV_COLUMNS.map(([key]) => csvCell(c[key])).join(","));
  return "\uFEFF" + [header, ...rows].join("\r\n");
}

export function downloadCSV(cards, filename = "dextyou-contacts.csv") {
  triggerDownload(buildCSV(cards), "text/csv;charset=utf-8", filename);
}

export function cardToText(card) {
  return [
    card.name,
    card.title,
    card.company,
    card.phone && `📞 ${card.phone}`,
    card.email && `✉ ${card.email}`,
    card.website && `🌐 ${card.website}`,
  ]
    .filter(Boolean)
    .join("\n");
}
